import React, { Component } from 'react';

class NotFound extends Component {
    render() {
        return (
            <div className="container-fluid">
                <h1>The requested URL is not found</h1>
            </div>
        );
    }
}
export default NotFound;


// WEBPACK FOOTER //
// ./src/components/layout/not-found/index.jsx